import { BtnCancel, ToastButton, ToastControlWrapper, ToastWrapper } from './Styled'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import actions from 'redux/action'
import { selectMobileConfigUpdateReason } from 'redux/selector/app'
import { MOBILE_CONFIG_UPDATE_REASON_ENTRY_DOMAIN } from 'redux/slice/app'
import MobileConfigUpdateFlow from './components/MobileConfigUpdateFlow'

export default function MobileConfigUpdate() {
  const dispatch = useDispatch()
  const reason = useSelector(selectMobileConfigUpdateReason)
  const handleClose = () => {
    dispatch(actions.updateShowMobileConfigUpdate(false))
    dispatch(actions.updateViewedMobileConfigUpdate(true))
  }

  const [updateFlowOpened, setUpdateFlowOpened] = useState(false)
  const message =
    reason === MOBILE_CONFIG_UPDATE_REASON_ENTRY_DOMAIN
      ? '系统检测线路过旧，请更新至最新版'
      : '请点击更新，获取最新体验'

  return (
    <React.Fragment>
      <ToastWrapper>
        {message}
        <ToastControlWrapper>
          <ToastButton onClick={() => setUpdateFlowOpened(true)}>前往更新</ToastButton>
          <BtnCancel onClick={handleClose} />
        </ToastControlWrapper>
      </ToastWrapper>
      <MobileConfigUpdateFlow isOpen={updateFlowOpened} onClose={() => setUpdateFlowOpened(false)} />
    </React.Fragment>
  )
}
